import Vue from 'vue'
import Vuex from 'vuex'
import tabsNav from './modules/tabsNav'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
	},
	getters: {
	},
	mutations: {
	},
	actions: {
	},
	modules: {
		tabsNav
	}
})
